module.exports = __webpack_public_path__ + "static/media/K2.fe2547d1.png";